"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillTagSelectField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const SkillTagSelect_1 = require("../../global/SkillTagSelect/SkillTagSelect");
const SkillTagSelectField = ({ name, label, rules, ...otherProps }) => {
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: name, label: label, rules: rules, children: (0, jsx_runtime_1.jsx)(SkillTagSelect_1.SkillTagSelect, { ...otherProps, isSkillPrimary: false }) }));
};
exports.SkillTagSelectField = SkillTagSelectField;
